export const firstNames = [
	"Awesome",
	"Boomer",
	"Cozy",
	"Dirty",
	"Elegant",
	"Furry",
	"Goofy",
	"Happy",
	"Intelligent",
	"Jolly",
	"Kind",
	"Lazy",
	"Mighty",
	"Nimble",
	"Obese",
	"Picky",
	"Quiet",
	"Rare",
	"Squeaky",
	"Turbulent",
	"Unique",
	"Vocal",
	"Witty",
	"Yelling",
	"Zoomer",
];

export const lastNames = [
  "Alligator",
  "Bear",
  "Cobra",
  "Dolphin",
  "Elephant",
  "Fox",
  "Goat",
  "Hen",
  "Iguana",
  "Jaguar",
  "Koala",
  "Lion",
  "Monkey",
  "Nilgai",
  "Owl",
  "Penguin",
  "Quail",
  "Rabbit",
  "Squirrel",
  "Tortoise",
  "Uakari",
  "Vulture",
  "Wolf",
  "Yak",
  "Zebra",
];

export const getAnomouNames = (records) => {
  const arr = [];
  const getName = () => {
    const fn = `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
    if (arr.find((emp) => emp.fullname == fn)) {
      getName();
    }
    return fn;
  };
  records.forEach((e) => {
    if (e.isfeedbackanonymous) {
      arr.push({
        ...e,
        fullname: getName(),
      });
    } else {
      arr.push(e);
    }
  });
  return arr;
};

// export const getAnomouNamesForSpider = (records) => {
//   const arr = [];
//   const getName = () => {
//     const fn = `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
//     if (arr.find((emp) => emp.fullname == fn)) {
//       getName();
//     }
//     return fn;
//   };
//   records.forEach((e) => {
//     if (e.isfeedbackanonymous) {
//       arr.push({
//         ...e,
//         fullname: getName(),
//       });
//     } else {
//       arr.push(e);
//     }
//   });
//   return arr;
// };
